
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#000032","d":"M0 0h200v200H0z"}}),_c('g',{attrs:{"fill":"#5a96ff"}},[_c('path',{attrs:{"d":"M58.91 105.13H38.42c-2.83 0-5.13 2.3-5.13 5.13s2.3 5.13 5.13 5.13H58.91c2.83 0 5.13-2.3 5.13-5.13s-2.3-5.13-5.13-5.13zM161.58 105.13H79.39c-2.83 0-5.13 2.3-5.13 5.13s2.3 5.13 5.13 5.13h82.18c2.83 0 5.13-2.3 5.13-5.13a5.12 5.12 0 00-5.12-5.13zM38.42 74.35H99.91c2.83 0 5.13-2.3 5.13-5.13s-2.3-5.13-5.13-5.13H38.42c-2.83 0-5.13 2.3-5.13 5.13s2.3 5.13 5.13 5.13zM161.58 125.65H99.92c-2.83 0-5.13 2.3-5.13 5.13s2.3 5.13 5.13 5.13h61.66c2.83 0 5.13-2.3 5.13-5.13s-2.3-5.13-5.13-5.13zM79.39 125.65H38.42c-2.83 0-5.13 2.3-5.13 5.13s2.3 5.13 5.13 5.13h40.97c2.83 0 5.13-2.3 5.13-5.13s-2.29-5.13-5.13-5.13zM120.44 84.61H38.42c-2.83 0-5.13 2.3-5.13 5.13s2.3 5.13 5.13 5.13h82.01c2.83 0 5.13-2.3 5.13-5.13a5.12 5.12 0 00-5.12-5.13zM161.58 84.61h-20.57c-2.83 0-5.13 2.3-5.13 5.13s2.3 5.13 5.13 5.13h20.57c2.83 0 5.13-2.3 5.13-5.13s-2.3-5.13-5.13-5.13zM120.44 74.35h41.14c2.83 0 5.13-2.3 5.13-5.13s-2.3-5.13-5.13-5.13h-41.14c-2.83 0-5.13 2.3-5.13 5.13s2.3 5.13 5.13 5.13z"}})])])
          )
        }
      }
    